module.exports = __webpack_public_path__ + "img/zixun_2@2x.cbfc7682.png";